import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageTabs, type PageTab } from "@components/CatalogIndex";
import useAccountHasEntitlement from "@common/hooks/useAccountHasEntitlement";
import "./ClientEditLayout.css";

export const ClientEditLayout = (): JSX.Element => {
  const { hasEntitlement } = useAccountHasEntitlement();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Active tab is derived from the current sub-route so the tab styling stays
  // in sync on direct navigation/refresh, not just clicks. All contacts
  // sub-routes (list/new/edit) keep the Contacts tab active.
  const activeKey = pathname.includes("/contacts")
    ? "contacts"
    : pathname.includes("/special_conditions")
    ? "special_conditions"
    : "client";

  const tabs: PageTab[] = [
    { key: "client", label: "Client" },
    { key: "contacts", label: "Contacts" },
    ...(hasEntitlement("terms-and-conditions")
      ? [{ key: "special_conditions", label: "Terms & Conditions" }]
      : []),
  ];

  // Route-relative navigation resolves against this layout's route (`:id`).
  const handleSelect = (key: string) =>
    navigate(key === "client" ? "edit" : key);

  return (
    <div className="client-edit-layout">
      <PageTabs activeKey={activeKey} onSelect={handleSelect} tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default ClientEditLayout;
